var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header"},[_c('div',{staticClass:"header__container"},[_c('NuxtLink',{attrs:{"to":"/projects"}},[_c('img',{staticClass:"header__logo",attrs:{"src":require("assets/images/logo/text-main.svg"),"alt":"サービスロゴ"}})])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }